import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/contentSplitSections.css';

const ContentSplitSections = ({ sections = [] }) => {
  if (!sections.length) return null; // fallback: no rendering if no data

  return (
    <section className="section bg-clean content-split-wrapper">
      <div className="split-overlay">{/* optional animated effects */}</div>
      <div className="section-inner split-content-wrapper">
        {sections.map(({ title, text, image, alt, reverse, buttonText, buttonLink, buttonText2, buttonLink2 }, index) => (
          <div
            key={index}
            className={`split-section ${reverse ? 'reverse' : ''}`}
            data-index={`0${index + 1}`} 
          >
            <div className="split-image">
              <img src={image} alt={alt || title} />
            </div>
            <div className="split-text">
              <h3>{title}</h3>
              {text.split('\n').map((line, i) => (
                <p key={i}>{line}</p>
              ))}
              {(buttonText && buttonLink) || (buttonText2 && buttonLink2) ? (
                <div style={{
                  marginTop: '2rem',
                  display: 'flex',
                  gap: '1rem',
                  alignItems: 'baseline',
                  justifyContent: (buttonText2 && buttonLink2 && !buttonText && !buttonLink) ? 'center' : 'flex-start'
                }}>
                  {buttonText && buttonLink && (
                    <Link
                      to={buttonLink}
                      className="btn-primary"
                      style={{
                        display: 'inline-block',
                        padding: '14px 32px',
                        fontSize: '1.1rem',
                        whiteSpace: 'nowrap',
                        verticalAlign: 'baseline',
                        lineHeight: '1.2'
                      }}
                    >
                      {buttonText}
                    </Link>
                  )}
                  {buttonText2 && buttonLink2 && (
                    <Link
                      to={buttonLink2}
                      className="btn-secondary"
                      style={{
                        display: 'inline-block',
                        padding: '14px 32px',
                        fontSize: '1.1rem',
                        whiteSpace: 'nowrap',
                        verticalAlign: 'baseline',
                        lineHeight: '1.2'
                      }}
                    >
                      {buttonText2} →
                    </Link>
                  )}
                </div>
              ) : null}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ContentSplitSections;